module.exports = __webpack_public_path__ + "static/img/img_tip4.501837d4.png";